export { Tabs, TabsContent, TabsList } from "ics-ui-kit/components/tabs";
export { TabsTrigger } from "./TabsTrigger";
